import { NO_BUDGET_WARNING, NOT_FINALISED_ERROR, STALE_BUDGET_WARNING } from '~constants/common';

import { Step } from '~components/wizard-form/props';
import UploadMultiple from '~support-at-home/components/config/budgets/UploadMultiple';

import { selectLookupClients } from '~main/selectors/clients/clients';

import Confirm from '../../components/claims/statements-wizard/Confirm';
import Introduction from '../../components/claims/statements-wizard/Introduction';
import Review from '../../components/claims/statements-wizard/Review';

const steps: Step[] = [
  {
    step: 1,
    title: 'Introduction',
    fields: {
      introduction: {
        type: 'custom',
        component: Introduction,
        colSize: 12,
      },
    },
  },
  {
    step: 2,
    title: 'Criteria',
    fields: {
      client_id: {
        type: 'multi-lookup',
        caption: 'Clients',
        className: 'align-items-baseline',
        selectorOptions: selectLookupClients,
        warning: 'Leave empty to generate statements for all clients within the selected month',
      },
      month: {
        type: 'month',
        caption: 'Statement Month',
        required: true,
        className: 'align-items-baseline',
      },
    },
  },
  {
    step: 3,
    title: 'Budget Balances',
    fields: {
      balances_notice: {
        type: 'alert-warning',
        deriveValue: () =>
          'Upload your clients up to date budgets from Aged Care Provider Portal to ensure accurate statements',
        colSize: 12,
      },
      aco_budgets_upload: {
        type: 'custom',
        component: UploadMultiple,
        colSize: 12,
        dependencies: ['client_id', 'month'],
      },
    },
  },
  {
    step: 4,
    title: 'Confirm',
    fields: {
      confirm: {
        type: 'custom',
        component: Confirm,
        colSize: 12,
        dependencies: ['month', 'client_id'],
      },
    },

    showNextButton: ({ values }) => {
      // Only allow next step if there are statements to generate
      const estimateData = values?.confirm?.data;
      return estimateData?.statements?.to_generate > 0;
    },
    confirmNext: ({ values }) => {
      const nonFinalisedExists = values?.confirm?.data?.errors?.some((err: any) => err.reason === NOT_FINALISED_ERROR);
      const staleBudgetExists = values?.confirm?.data?.warnings?.some(
        (err: any) => err.reason === STALE_BUDGET_WARNING,
      );
      const noBudgetExists = values?.confirm?.data?.warnings?.some((err: any) => err.reason === NO_BUDGET_WARNING);

      const messages: string[] = [];
      if (nonFinalisedExists) messages.push('Some affected claims have not yet been finalised.');
      if (staleBudgetExists) {
        messages.push(
          'Some clients have Support At Home budgets which have not been updated within the last 24 hours.',
        );
      }
      if (noBudgetExists) messages.push('Some clients have no Support At Home budget for the statement period');

      return messages.length > 0 ? { messages } : null;
    },
  },
  {
    step: 5,
    title: 'Review',
    fields: {
      review: {
        type: 'custom',
        component: Review,
        colSize: 12,
        dependencies: ['client_id', 'month'],
      },
    },
    showPrevButton: false,
  },
];

export default steps;
